module.exports = __webpack_public_path__ + "static/media/Plus.61791849.svg";